import RPALGO_EXT_1 from "./RPALGO_EXT_1";
export default {
  RPALGO_EXT_1,
};
